import React,{useState,useRef,useEffect} from 'react'
import { DataGrid, UploadModal,EditModal } from '../../../common'
import editIcon from "../../../assets/edit.svg";
import { onDownloadXlsFile ,getCultureFromLs} from '../../../utils/commonFunctions'
import { IoBan } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";
import { APIEndpoint } from '../../../utils/axios'
import closeIcon from "../../../images/icons/Icon2.png"
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import usePermissions from '../../../utils/userPermissions';
import moment from 'moment';

const filters = {
  action: 4,
  collection: '',
  filterOperation: 'or',
  filters: [],
  limit: 50,
  page: 1,
  searchParam: ''
};

export const Ssrcodes = () => {
  const [state, setState] = useState({showUpload:false,selected:null})
  const [uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [uploadedFile, setUploadedFile] = useState([]);
  const [isReloadTable, setIsReloadTable] = useState(false);
  const [message, setMessage] = useState({text:""});
  const [modalCustomButtons, setModalCustomButtons] = useState([]);
    const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });

   const [modalTitle, setModalTitle] = useState([]);
    const stateRef=  useRef(null);
  const { hasPermission: viewSSR } = usePermissions('view', 'configuration.fsc.ssr');
  const { hasPermission: editSSR } = usePermissions('edit', 'configuration.fsc.ssr');
  const { hasPermission: uploadSSR } = usePermissions('upload', 'configuration.fsc.ssr');
useEffect(() => {
 stateRef.current = state;
}, [state])

  const ActionCell = (params)=>{
  
    if(!params?.data &&!editSSR) return null;
    if(!params.data)return null;
    return (<>
 { params.data?.status==='active'? <span className='aircraft-actions' title='Deactivate SSR' onClick={(e) => {
  e.stopPropagation();
  setModalTitle(`Deactivate SSR - ${params.data.code}`);
   setModalCustomButtons([{label:'Deactivate',attribute:'button',type:"button",disabled:false,className:'cancel-button',action:onSaveSSR}])
  setState(prev=>({...prev,selected:{type:'deactivate',...params?.data}}))}}>
                <IoBan size={20} className="scanqr-uplift" />
              </span>:params.data.status==='inactive'?<span className='aircraft-actions' title='Activate SSR' onClick={(e) =>{
                 e.stopPropagation();
  setModalTitle(`Activate SSR - ${params.data.code}`);
   setModalCustomButtons([{label:'Activate',attribute:'button',type:"button",disabled:false,className:'done-button',action:onSaveSSR}])
                setState(prev=>({...prev,selected:{type:'activate',...params?.data}}))}}>
                <FaCheck size={20} className="scanqr-uplift" />
              </span>:null}
    <img className='aircraft-actions' alt='edit' title='Edit SSR' onClick={(e) => setState(prev=>({...prev,selected:{type:'edit',...params?.data}}))} src={editIcon}/>
  </>)
  }

  const Columns = [
    {field:"code",headerName:"SSR Code",flex:1,minWidth:150,width:170,resizable:true},
    {field:"description",headerName:"Description",flex:1,cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },resizable:true,minWidth:160,width:180},
    {field:"allowMultipleItemBindings",headerName:"Allow Multiple Item Bindings",valueGetter:params=>{
      return params?.data?.allowMultipleItemBindings ? "Yes":params?.data ? "No":null
    },width:55,minWidth:40,flex:1},
    {field:"seatUpgradeEnabled",headerName:"Seat Upgrade Enabled",valueGetter:params=>{
      return params?.data?.seatUpgradeEnabled ? "Yes":params?.data ? "No":null
    },width:55,minWidth:40,flex:1},
    {
        field: "status",
        headerName: "Status",
        valueGetter: (params) => {
          if (params.data&&params.data.status) {

            return params.data.status.charAt(0).toUpperCase()+params.data.status.slice(1)
          }
          return null;
        },
        sortable: false,
        filter: false,
        flex:1,
        minWidth: 100,
        width:110,
        autoHeight: true,
      },
    {field:"createdAt",headerName:"Created At",valueGetter:params=>params.data?.createdAt ? moment(params.data?.createdAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):null,flex:1},
    {field:"modifiedAt",headerName:"Last Modified At",valueGetter:params=>params.data?.modifiedAt ? moment(params.data?.modifiedAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):null,flex:1},
    {field:"actions",headerName:"Actions",cellRenderer:ActionCell,width:100,minWidth:100},
  ]

  async function fetchSSR(iPageNo = 1, iPageLimit = 50,search){
    filters.searchParam = ""
    filters.page = iPageNo;
    filters.limit = iPageLimit
    if(search){
      filters.searchParam = search
    }
    try {
      const res = await APIEndpoint.post("ssr/process",JSON.stringify(filters))
      return res;
    } catch (error) {

    }
  }
  function onUploadClose(){
    setState(prev=>({...prev,showUpload:false,selected:null}))
    setModalFormStatusObj({ text:'' });
    setMessage({text:""})
    setUploadFileStatusBlock("")
  }
  const onDownloadSampleFile = async (e) => {
    onDownloadXlsFile('samples/downloads/SSR_Upload_Sample', 'SSR_Upload_Sample')
  }
  async function handleUploadSSR(e){
    try {
      const file=e.target.files[0];
      setUploadedFile(e.target.files[0]);
      setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');
      const formData = new FormData();
      formData.append('scheduleLater', false);
      formData.append('listName', undefined);
      formData.append('targetSectorType', undefined);
      formData.append('stores', []);
      formData.append('warehouses', []);
      formData.append('file', file);
      await APIEndpoint.post("ssr/upload",formData)
      setUploadedFile([]);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setTimeout(() => {
        setUploadFileStatusBlock('');
        setState(prev=>({...prev,showUpload:false}))
        setIsReloadTable(!isReloadTable)
      }, 2000);
    } catch (error) {
      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400) {
        if(data.errors){
                data.errors?.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
        }else{
          msgContent += `Failed to upload ssr.`;
        }
      } else if(status===0 && !data){
        msgContent += `Error occurred while uploading ssr sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading ssr sheet!<br>Please fix the errors and re-upload.`;
      }
      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
  }
  async function onSaveSSR(){

    if(stateRef.current.selected && stateRef.current.selected.type==='edit'){
      try {
        const updated = {
          description:stateRef.current.selected?.description,
          allowMultipleItemBindings:stateRef.current.selected?.allowMultipleItemBindings,
          seatUpgradeEnabled:stateRef.current.selected?.seatUpgradeEnabled
        }
        const res = await APIEndpoint.put(`ssr/${stateRef.current.selected.id}`,updated)
        if(res && res.success){
          setIsReloadTable(!isReloadTable)
          setMessage({text:res?.message||"success"})
          setTimeout(() => {
            setState((prev)=>({...prev,selected:null}))
            setMessage({text:""});
          }, 2000);
        }
      } catch (error) {
        let { data } = JSON.parse( error.message );
        let msgHeading = data?.Error || data?.message || error.message;
        setMessage({error:msgHeading??"Something went wrong. Please try again after some time."});
      }
    }else {

  const cancelBtn = document.querySelector('.done-button.cancel-button');
  const doneBtn = document.querySelector('.done-button.done-button');

  const submitDisabled = cancelBtn || doneBtn;

  if (submitDisabled) {
    submitDisabled.disabled = true;
  }

  try {
    const updated = {
      action: stateRef.current.selected?.type
    };

    const res = await APIEndpoint.put(
      `ssr/${stateRef.current.selected.id}/status`,
      updated
    );

    if (res && res.success) {
      setModalFormStatusObj({ text: res?.message || 'Success' });

      setTimeout(() => {
        setState((prev) => ({ ...prev, selected: null }));
        setModalFormStatusObj({ text: '' });
        setIsReloadTable(!isReloadTable);
      }, 2000);
    }
  } catch (error) {
    let parseErr = {};
    try {
      parseErr = JSON.parse(error?.message);
    } catch (e) {
      // If parsing fails, use the raw error message
      parseErr = { data: { message: error?.message } };
    }
    if (submitDisabled) {
      submitDisabled.disabled = false;
    }

    setModalFormStatusObj({
      error: parseErr?.data?.message || "Something went wrong. Please try again after some time."
    });
  }
}

  }
  return (

    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">

      {viewSSR && <DataGrid
        className="full-flex"
        columns={[...Columns]}
        showDefaultFilters={true}
        getRows={fetchSSR}
        columnResize={true}
        rowSelection="multiple"
        resetDataSource={isReloadTable}
        RightComponent={() => {
          return uploadSSR ? (
            <div className='flexRow width100 justifyContentFlexEnd'>
              <button
              title={'Upload SSR'}
                className='dropdownStyle1-TextMedium'
                onClick={() => setState((prev) => ({ ...prev, showUpload: true }))}
              >
                <span>
                  <img className="icon-size-min" alt='uploadItem' src={uploadItemIcon} />
                </span>
              </button>
            </div>
          ) : null;
        }}

      />}

      <>
       {
      state.showUpload &&
      <UploadModal
         onUploadFileChangeHandler={handleUploadSSR}
        modelTitle={"Upload SSR"}
       onUploadClose={onUploadClose}
       onDownloadSampleFile={onDownloadSampleFile}
       uploadFileStatusBlock = { uploadFileStatusBlock }
        uploadedFile={uploadedFile}
       />
     }
     {
       state.selected && state.selected.type==='edit'?  (
         <div className="overlay" role="dialog">
            <div className="dialog sm-scrollbar">
             <div className="dialog__content">
            <img
                 className="modal__close_icon"
                 alt="Close"
                  src={closeIcon}
                 onClick={onUploadClose}
                />
               <h2 className="dialog__title subheading-text-medium fontMedium">
                   Edit SSR - {state.selected?.code}
                </h2>
                <hr />
                <div className="dialog__body_container flexRow mt-4 justifyContentCenter flexWrap">
                  <div className={`dialog__container_item input-container`}>
                    <div className="flexCol margBot10">
                      <label htmlFor="">Description</label>
                      <textarea className='edit-input ' rows="4" name="" id="" value={state.selected?.description} onChange={(e)=>{
                        setState((prev)=>({...prev,selected:{...prev.selected,description:e.target.value}}))
                      }}></textarea>
                    </div>
                       <div className="flex alignItemsCenter margBot10">
                      <input className='margRight10' id='allowMultipleItemBindings' type="checkbox" checked={state.selected?.allowMultipleItemBindings} onChange={e=>{
                        setState((prev)=>({...prev,selected:{...prev.selected,allowMultipleItemBindings:e.target.checked}}))
                      }} />
                      <label htmlFor="allowMultipleItemBindings">Allow multiple item bindings</label>
                    </div>
                    <div className="flex alignItemsCenter margBot10">
                      <input className='margRight10' id='seatUpgradeEnabled' type="checkbox" checked={state.selected?.seatUpgradeEnabled} onChange={e=>{
                        setState((prev)=>({...prev,selected:{...prev.selected,seatUpgradeEnabled:e.target.checked}}))
                      }} />
                      <label htmlFor="seatUpgradeEnabled">Seat upgrade enabled</label>
                    </div>
                    <div className="dialog__footer flexCol alignItemsCenter">
                      <button onClick={onSaveSSR} className='done-button'>Save</button>
                    </div>

                  </div>
                  <div className='flexRow width100'>
                 
                    {(message.text?.length || message.error?.length) ? (
            <div style={{padding:'0.2rem',marginBottom:'8px'}} className={"width100 dialog__statusBlock " + (message && message?.error?.length ? 'alert_error':'alert_success')}>
            <h6 className="subheading-text-medium-title fontLight">
              {message.text || message.error}
            </h6>
            </div>
          ) : null}
                  </div>

                </div>
              </div>
            </div>
      </div>
      ):null}

      {
            Boolean(state?.selected) && state.selected.type!=='edit' ? (
            <EditModal
            mainContentCenter
            key={state.selected.type}
            title={ modalTitle }
            onClose={onUploadClose}
            modalFormStatusObj={modalFormStatusObj}
            onSubmit={onSaveSSR}
            disabled={state.disabled}
            modalCustomButtons={modalCustomButtons}
           
            fields={[]}
            />
            )
            : null
            }
      </>

    </div>
  )
}
